// Occupancy counter for the manual-booking form (mirrored from ServiceInfoEditor).

export interface StepperProps {
  label: string;
  value: number;
  onChange: (v: number) => void;
  min?: number;
}

export function Stepper({ label, value, onChange, min = 0 }: StepperProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="w-20 text-sm text-foreground">{label}</span>
      <button
        type="button"
        aria-label={`${label} minus`}
        className="flex h-7 w-7 items-center justify-center rounded border border-[var(--border-hairline)] bg-card text-sm hover:bg-[var(--surface-sunken)] disabled:opacity-40"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
      >
        −
      </button>
      <span className="w-6 text-center text-sm tabular-nums">{value}</span>
      <button
        type="button"
        aria-label={`${label} plus`}
        className="flex h-7 w-7 items-center justify-center rounded border border-[var(--border-hairline)] bg-card text-sm hover:bg-[var(--surface-sunken)]"
        onClick={() => onChange(value + 1)}
      >
        +
      </button>
    </div>
  );
}
